import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

// 重写路由的push方法

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}
const routes = [{
    path: '/',
    name: 'Home',
    component: Home,
    meta: {title: '首页', isHome: true}
},
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/About.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: () =>
            import ('../views/user/login.vue'),
        meta: {title: '注册/登陆'}
    },
    {
        path: '/fileshow',
        name: 'PDFShow',
        component: () =>
            import ('../views/repair/PDFShow.vue'),
        meta: {title: '查阅', requiresAuth: true}
    },
    {
        path: '/repair/caselist',
        name: 'CaseList',
        component: () =>
            import ('../views/repair/CaseList.vue'),
        meta: {title: '案例列表'}
    },
    {
        path: '/repair/:type/:pId',
        name: 'CarChoose',
        component: () =>
            import ('../views/repair/Choose.vue'),
        meta: {title: '查询'}
    },
    {
        path: '/repair/:type',
        name: 'Repair',
        component: () =>
            import ('../views/repair/index.vue'),
        meta: {title: '查询'}
    },
    {
        path: '/filemenu/:id',
        name: 'FileMenu',
        component: () =>
            import ('../views/repair/FileMenu.vue'),
        meta: {title: '文件目录', requiresAuth: true}
    },
    {
        path: '/user/index',
        name: 'User',
        component: () =>
            import ('../views/user/index.vue'),
        meta: {title: '用户中心', requiresAuth: true}
    },
    {
        path: '/user/info',
        name: 'UseInfo',
        component: () =>
            import ('../views/user/info.vue'),
        meta: {title: '个人资料', requiresAuth: true}
    },
    {
        path: '/user/case',
        name: 'case',
        component: () =>
            import ('../views/user/case.vue'),
        meta: {title: '案例', requiresAuth: true}
    },
    {
        path: '/user/product',
        name: 'Product',
        component: () =>
            import ('../views/user/product.vue'),
        meta: {title: '购买VIP', requiresAuth: true, isBuy: true}
    },
    {
        path: '/user/score',
        name: 'Score',
        component: () =>
            import ('../views/user/Score.vue'),
        meta: {title: '我的积分', requiresAuth: true}
    },
    {
        path: '/tips',
        name: 'Product',
        component: () =>
            import ('../views/Tips.vue'),
        meta: {title: '购买VIP', requiresAuth: true}
    },
    {
        path: '/pc/',
        name: 'Home',
        component: () =>
            import ('../views/pc/index.vue'),
        meta: {title: '首页', requiresAuth: false, isHome: true}
    },
    {
        path: '/pc/newslist',
        name: 'NewsList',
        component: () =>
            import ('../views/pc/NewsList.vue'),
        meta: {title: '新闻列表'}
    },
    {
        path: '/pc/choose/:type',
        name: 'pc_choose',
        component: () =>
            import ('../views/pc/Choose.vue'),
        meta: {title: '购买VIP', requiresAuth: false} //
    },
    {
        path: '/pc/fileshow/:id',
        name: 'PDFShow',
        component: () =>
            import ('../views/pc/PDFShow.vue'),
        meta: {title: '查阅', requiresAuth: true}
    },
    {
        path: '/pc/contactus',
        name: 'PDFShow',
        component: () =>
            import ('../views/pc/ContactUs.vue'),
        meta: {title: '查阅', requiresAuth: false}
    },
    {
        path: '/pc/product',
        name: 'Product',
        component: () =>
            import ('../views/pc/product.vue'),
        meta: {title: '查阅', requiresAuth: true, isBuy: true}
    },
    {
        path: '/pc/wxpay/:pId/:no',
        name: 'WxPay',
        component: () =>
            import ('../views/pc/WxPay.vue'),
        meta: {title: '查阅', requiresAuth: true}
    },

    {
        path: '/jumpmp',
        name: 'Jumpmp',
        component: () => import ('../views/user/jumpmp.vue'),
        meta: {title: '转到小程序'}
    },
    {
        path: '/liangdian',
        name: 'liangdian',
        component: () => import ('../views/repair/liangdian.vue'),
        meta: {title: '资料亮点'}
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router
